import React from 'react';
import type { LstPeriodView } from './PeriodSwitcher';
import type { TplOeeMetrics } from '../services/lstOeeMetrics';
import { MeuPadraoHeaderFilters } from './MeuPadraoHeaderFilters';

export interface LeaderSelectOption {
  id: string;
  name: string;
}

export interface MeuPadraoSubHeaderProps {
  periodView: LstPeriodView;
  onPeriodChange: (view: LstPeriodView) => void;
  roleLabel: string;
  departmentLabel?: string | null;
  dateLabel: string;
  oee?: TplOeeMetrics | null;
  leaderOptions?: LeaderSelectOption[];
  selectedLeaderId?: string;
  onLeaderChange?: (userId: string) => void;
  viewingSubordinate?: boolean;
  className?: string;
}

const PERIOD_TITLES: Record<LstPeriodView, string> = {
  dia: 'Meu Padrão de Trabalho',
  semana: 'Matriz Semanal Kamishibai',
  mes: 'Matriz Mensal Kamishibai',
};

const PERIOD_CONTEXT: Record<LstPeriodView, string> = {
  dia: 'Execução diária',
  semana: 'Visão semanal · Kamishibai',
  mes: 'Visão mensal · Kamishibai',
};

/**
 * Sub-header executivo — título à esquerda; período e líder à direita.
 */
export const MeuPadraoSubHeader = React.memo<MeuPadraoSubHeaderProps>(function MeuPadraoSubHeader({
  periodView,
  onPeriodChange,
  roleLabel,
  departmentLabel,
  dateLabel,
  oee,
  leaderOptions,
  selectedLeaderId,
  onLeaderChange,
  viewingSubordinate = false,
  className = '',
}) {
  return (
    <header
      className={`flex w-full shrink-0 flex-row items-center border-b border-slate-200 bg-slate-50 px-4 py-2.5 dark:border-slate-800 dark:bg-slate-900/40 ${className}`}
    >
      <div className="flex w-full items-center justify-between gap-4">
        <div className="min-w-0 shrink">
          <h3 className="truncate text-[13px] font-bold text-slate-800 dark:text-slate-100">
            {PERIOD_TITLES[periodView]}
          </h3>
          <p className="truncate text-[11px] text-slate-500 dark:text-slate-400">
            {PERIOD_CONTEXT[periodView]}
            {' · '}
            {roleLabel}
            {departmentLabel ? ` · ${departmentLabel}` : ''}
            {' · '}
            {dateLabel}
            {viewingSubordinate && (
              <span className="ml-1.5 rounded bg-violet-100 px-1.5 py-0.5 text-[10px] font-semibold text-violet-700 dark:bg-violet-950/40 dark:text-violet-300">
                Visualização
              </span>
            )}
            {periodView === 'dia' && oee && (
              <>
                {' · '}
                Disciplina{' '}
                <strong className="font-semibold text-slate-700 dark:text-slate-200">{oee.disciplinaPct}%</strong>
                {' · '}
                Conf.{' '}
                <strong className="font-semibold text-slate-700 dark:text-slate-200">{oee.conformidadePct}%</strong>
              </>
            )}
          </p>
        </div>

        <MeuPadraoHeaderFilters
          periodView={periodView}
          onPeriodChange={onPeriodChange}
          leaderOptions={leaderOptions}
          selectedLeaderId={selectedLeaderId}
          onLeaderChange={onLeaderChange}
        />
      </div>
    </header>
  );
});

export default MeuPadraoSubHeader;
